export const SET_ELE_REPORT_LOADING = 'SET_ELE_REPORT_LOADING'
export const SET_ELE_REPORT = 'SET_ELE_REPORT'